import appErrorWrapper from "../App/AppErrorWrapper";
import ChosenAppLayout from "./ChosenAppLayout";

const errorWrappedApp = appErrorWrapper((props) => {
  return <ChosenAppLayout {...props} />;
});

export default errorWrappedApp;
